<template>
  <div
    class="member-quote"
  >
    <div class="member-quote__wrapper">
      <cdr-img
        v-if="image"
        :src="image?.src"
        :alt="image?.alt"
        loading="lazy"
        class="member-quote__image"
      />
      <div>
        <div>
          <p
            v-if="quote"
            class="member-quote__quote"
            v-html="quoteValue"
          />
          <p
            v-if="author"
            class="member-quote__author"
            v-html="authorValue"
          />
          <add-membership-to-cart
            v-if="!user.isMember"
            :is-added-to-cart="membershipInCart"
            :cta-text="homePageInjectables.addMembershipToCart"
            class="member-quote__btn"
            cta-full-width="@xs"
            data-analytics-config="exclude"
            @click="handleClick"
            @error="handleError"
            @success="$emit('success')"
            @warn="handleWarn"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CdrImg } from '@rei/cedar';
import AddMembershipToCart from '@rei/add-membership-to-cart';
import { metricsLinkAddToCart } from '../../../utils/analytics';

export default {
  name: 'MemberQuote',
  components: {
    AddMembershipToCart,
    CdrImg,
  },
  inject: ['userInformation', 'homePageInjectables'],
  props: {
    quote: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      required: true,
    },
    membershipInCart: {
      type: Boolean,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
  },
  emits: ['error', 'success', 'warn'],
  computed: {
    user() {
      return this.userInformation.user;
    },
    quoteValue() {
      return this.quote ? `&#8220;${this.quote}&#8221;` : null;
    },
    authorValue() {
      return this.author ? `-${this.author}` : null;
    },
  },
  methods: {
    /* c8 ignore start */
    handleClick() {
      metricsLinkAddToCart(`member-quote_${this.homePageInjectables.addMembershipToCart}`);
    },
    handleError(message) {
      this.$emit('error', message);
    },
    handleWarn(message) {
      this.$emit('warn', message);
    },
    /* c8 ignore end */
  },
};
</script>

<style lang="scss">

.member-quote {
  .member-quote__quote {
    @include cdr-text-heading-serif-800;
    color: $cdr-color-text-button-primary-hover;
    margin-bottom: $cdr-space-three-quarter-x;
    @include cdr-md-mq-down {
      @include cdr-text-heading-serif-600;
    }
    @include cdr-xs-mq-only {
      margin-left: $cdr-space-two-x;
      margin-right: $cdr-space-one-x;
    }
  }
  .member-quote__author {
    @include cdr-text-subheading-sans-400;
    color: $cdr-color-text-button-primary-hover;
    margin-bottom: $cdr-space-three-quarter-x;
    @include cdr-xs-mq-only {
      margin-left: $cdr-space-two-x;
      margin-right: $cdr-space-two-x;
    }
  }
  .member-quote__btn {
    margin-top: $cdr-space-two-x;
  }
}
.member-quote__column {
  margin-bottom: $cdr-space-three-x;
  @include cdr-sm-mq-up {
    margin-left: $cdr-space-two-x;
    margin-right: $cdr-space-two-x;
  }
}
.member-quote__wrapper {
  display: grid;
  column-gap: $cdr-space-three-x;
  place-items: center;
  grid-template-columns: 1fr 2fr;
  @include cdr-container;
  @include cdr-md-mq-down {
    grid-template-columns: repeat(2, 1fr);
  }
  @include cdr-xs-mq-only {
    grid-template-columns: 1fr;
  }
}
</style>
